import { render, staticRenderFns } from "./ModuleSetTrainer.vue?vue&type=template&id=f8c3ddd6&scoped=true&lang=pug&"
import script from "./ModuleSetTrainer.vue?vue&type=script&lang=js&"
export * from "./ModuleSetTrainer.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSetTrainer.vue?vue&type=style&index=0&id=f8c3ddd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c3ddd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
